import { getToken } from '../util/auth'

/**
 * 利用form下载文件方法
 * @param {string} url 下载接口api，默认 '/base/file/download'
 * @param {object} data 下载接口所需参数
 */
export function downloadByForm({ url = '/base/file/download', data = {} }) {
  // 动态创建iframe和form
  const iframe = document.createElement('iframe')
  iframe.setAttribute('style', 'display:none')
  iframe.name = 'downFrame'
  const form = document.createElement('form')
  form.target = 'downFrame'
  form.setAttribute('style', 'display:none')
  form.method = 'GET'
  iframe.appendChild(form)
  document.body.appendChild(iframe)

  // 处理参数，放进form里
  const token = getToken()
  const allData = Object.assign({}, data, { token })
  for (const key in allData) {
    if (!Object.prototype.hasOwnProperty.call(allData, key)) continue
    const input = document.createElement('input')
    input.tpye = 'hidden'
    input.name = key
    input.value = allData[key]
    form.appendChild(input)
  }

  form.action = url
  form.submit()

  setTimeout(() => {
    document.body.removeChild(iframe)
  }, 30000)
}

export function getOuterHeight(dom) {
  if (
    dom === 'null' ||
    dom === null ||
    dom === 'undefined' ||
    dom === undefined ||
    dom === ''
  )
    return 0
  function getStyle(obj, attr) {
    if (obj.currentStyle) {
      return obj.currentStyle[attr]
    } else {
      return document.defaultView.getComputedStyle(obj, null)[attr]
    }
  }
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    // ie浏览器
    return dom.offsetHeight
  } else {
    var marginTop = getStyle(dom, 'marginTop')
    var marginBottom = getStyle(dom, 'marginBottom')
    var height = dom.offsetHeight
    return parseInt(marginTop) + parseInt(marginBottom) + height
  }
}

export function getOuterWidth(dom) {
  if (
    dom === 'null' ||
    dom === null ||
    dom === 'undefined' ||
    dom === undefined ||
    dom === ''
  )
    return 0
  function getStyle(obj, attr) {
    if (obj.currentStyle) {
      return obj.currentStyle[attr]
    } else {
      return document.defaultView.getComputedStyle(obj, null)[attr]
    }
  }
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    // ie浏览器
    return dom.offsetWidth
  } else {
    var marginLeft = getStyle(dom, 'marginLeft')
    var marginRight = getStyle(dom, 'marginRight')
    var width = dom.offsetWidth
    return parseInt(marginLeft) + parseInt(marginRight) + width
  }
}

export function IEVersion() {
  var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
  var isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器
  var isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion == 7) {
      return 7
    } else if (fIEVersion == 8) {
      return 8
    } else if (fIEVersion == 9) {
      return 9
    } else if (fIEVersion == 10) {
      return 10
    } else {
      return 6 //IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' //edge
  } else if (isIE11) {
    return 11 //IE11
  } else {
    return -1 //不是ie浏览器
  }
}

export function isIe() {
  return IEVersion() !== -1
}
